import { RangeSliderProps, Stack } from '@chakra-ui/react';
import { RangePicker } from './RangePicker';

export type RangePickerProps = RangeSliderProps & {
  minLabel?: string;
  maxLabel?: string;
};

export const RangeFilter = (props: RangePickerProps) => {
  return (
    <Stack py="4" px="4" spacing="6">
      <RangePicker {...props} />
    </Stack>
  );
};
